<!--
справка за АС за които има работни дни БГВ а няма м3 по абонати
if wd_hw>0 and sum(e_hot_water) = 0
-->
<template>
	<panel-base :checked="data!==null" :ok="data && data.length===0" :loading="loading" @start="start" @stop="stop">
		<template #heading>
			Станции с работни дни БГВ и без разпределена енергия за вода
			<span v-if="data">
				({{ data.length }})
			</span>
		</template>
		<template #content v-if="data">
			<station-list
				:utility="utility"
				:session="session"
				:items="data"
			/>
		</template>
	</panel-base>
</template>
<script>
import expansionPanelShort from "@/ittijs/ExpansionPanelShort";
import PanelBase from "@/views/report/checks/panelBase";
import checkMixin from "@/views/report/checks/checkMixin";
import StationList from "@/views/report/checks/station-list";

export default {
	components: {StationList, PanelBase},
	mixins: [
		expansionPanelShort,
		checkMixin(
			(self, getController) => self.imodel.yesWorkDaysHwNoM3(self.session, getController)
		),
	],
	props: [
		'utility',
		'session',
		'imodel',
	],
	watch: {
		utility(){ this.reset() },
		session(){ this.reset() },
	},
}
</script>